__webpack_require__.p = "/reports-translations-refactor/referrals-hub/";